export type MeetWlbTutorialKey = 'introduction' | 'homePage';

export const tutorialForAudience = (
  isAuthenticated: boolean,
): MeetWlbTutorialKey => isAuthenticated ? 'homePage' : 'introduction';
